import * as THREE from "three";
import { ControlContext } from "../ControlContext";
import { useContext, useEffect, useRef } from "react";
import { useLoader } from "@react-three/fiber";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { withCrossOrigin } from "../utils/ensureTextureCrossOrigin";

export default function SimpleCeiling() {
  const colorMap = useLoader(
    TextureLoader,
    "/models/CEILING.webp",
    withCrossOrigin
  );
  const { wallColor } = useContext(ControlContext);
  const ceilingColor = "#e8e3e3"
  return (
    <>
      <mesh position={[0, 120, 250]} rotation={[Math.PI / 2, 0, Math.PI]}>
        <planeGeometry args={[500,500]} />
        <meshBasicMaterial map={colorMap} color={ceilingColor} />
      </mesh>
    </>
  );
}
